import { render } from "./ProjectReference.vue?vue&type=template&id=67da2fea"
import script from "./ProjectReference.vue?vue&type=script&lang=js"
export * from "./ProjectReference.vue?vue&type=script&lang=js"

import "./ProjectReference.vue?vue&type=style&index=0&id=67da2fea&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__